import { useLayoutEffect } from 'react'
import type { RefObject } from 'react'

export const useAutoresizeTextarea = (
  ref: RefObject<HTMLTextAreaElement | null>,
  { minRows = 2, maxRows = 12 }: { minRows?: number; maxRows?: number } = {},
) => {
  useLayoutEffect(() => {
    const textarea = ref.current
    if (!textarea) return
    const lineHeight = Number.parseFloat(getComputedStyle(textarea).lineHeight) || 20
    textarea.style.height = 'auto'
    textarea.style.height = `${Math.min(Math.max(textarea.scrollHeight, lineHeight * minRows), lineHeight * maxRows)}px`
  })
}
